import { createReducer } from "@reduxjs/toolkit";
import {
  resetEducationalAdvisorRetrieveEvaluationsGroupedByStudent,
  educationalAdvisorRetrieveEvaluationsGroupedByStudent,
} from "./retrieve-evaluations-grouped-by-student";
import type { RetrievalState } from "@redux/state/shared-types";
import type { StudentEvaluationVM } from "@shared-kernel/application/ports/educational-advisor/educational-advisor-repository";

const initialState: RetrievalState<StudentEvaluationVM[]> = { fetching: "idle", data: [] };

export const educationalAdvisorRetrieveEvaluationsGroupedByStudentReducer = createReducer<RetrievalState<StudentEvaluationVM[]>>(
  initialState,
  builder => {
    builder.addCase(educationalAdvisorRetrieveEvaluationsGroupedByStudent.fulfilled, (state, { payload }) => {
      return {
        ...state,
        data: payload,
        fetching: "success",
      };
    });
    builder.addCase(educationalAdvisorRetrieveEvaluationsGroupedByStudent.pending, state => {
      return {
        ...state,
        fetching: "pending",
      };
    });
    builder.addCase(educationalAdvisorRetrieveEvaluationsGroupedByStudent.rejected, state => {
      return {
        ...state,
        fetching: "failed",
      };
    });
    builder.addCase(resetEducationalAdvisorRetrieveEvaluationsGroupedByStudent, () => {
      return initialState;
    });
  },
);
